import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { AlertTriangle, TrendingDown, ArrowRight } from "lucide-react";

export default function TrendBanner() {
  const [trend, setTrend] = useState(null);

  useEffect(() => {
    api.get("/trends/deterioration").then((r) => setTrend(r.data)).catch(() => {});
  }, []);

  if (!trend || trend.severity === "stable") return null;

  const isHigh = trend.severity === "high";
  return (
    <div
      data-testid="trend-banner"
      className={`rounded-2xl border p-4 flex items-start gap-3 ${
        isHigh ? "bg-red-50 border-red-200 text-red-900" : "bg-amber-50 border-amber-200 text-amber-900"
      }`}
    >
      {isHigh ? <AlertTriangle className="w-5 h-5 mt-0.5" /> : <TrendingDown className="w-5 h-5 mt-0.5" />}
      <div className="flex-1">
        <div className="font-semibold">{isHigh ? "Things look heavier than usual" : "A small dip this week"}</div>
        <div className="text-sm mt-0.5">
          Your check-ins and mood entries show a {isHigh ? "significant" : "gentle"} rise in distress this week. Want to do a quick check-in or speak to your AI companion?
        </div>
        <div className="mt-3 flex flex-wrap gap-2">
          <Link to="/checkin" data-testid="trend-checkin" className="text-sm bg-white border border-slate-200 hover:bg-slate-50 text-slate-800 rounded-xl px-3 py-1.5 flex items-center gap-1">
            Quick check-in <ArrowRight className="w-3.5 h-3.5" />
          </Link>
          <Link to="/assistant" data-testid="trend-assistant" className="text-sm bg-teal-700 hover:bg-teal-800 text-white rounded-xl px-3 py-1.5">
            Talk to companion
          </Link>
        </div>
      </div>
    </div>
  );
}
